import React from 'react';
import {Box, Center, VStack, Image, useTheme} from '@chakra-ui/react';
import {TextA18, TextG14} from '../../components/typography';
import {APPLE_STORE_LINK, GOOGLE_STORE_LINK} from '../../constants/appStores';
import ExternalLink from '../../components/ExternalLink';
import Logo from '../../assets/logos/Word_logo3.png';
import AppStoreImage from '../../assets/images/app-store-btn.png';
import PlayStoreImage from '../../assets/images/play-store-btn.png';
import PhoneImage from '../../assets/images/phone-download.png';

const MobileDownloadApp = () => {
  const theme = useTheme();

  return (
    <Box p={6} w="100%" minH="100vh" bg="white">
      <VStack spacing={6} textAlign="center">
        {/* Logo */}
        <Center mt={4}>
          <Image boxSize="50%" height="auto" src={Logo} alt="Walkabout Logo" />
        </Center>

        {/* Main Heading */}
        <VStack spacing={4}>
          <TextA18
            fontSize="28px"
            lineHeight="36px"
            fontWeight="700"
            color={theme.colors.darkGrey || '#333'}>
            Download the Walkabout App to continue!
          </TextA18>
          {/* <TextG14
            fontSize="16px"
            lineHeight="22px"
            fontWeight="400"
            color={theme.colors.grey || '#666'}
            px={4}>
            Download the Walkabout app to discover local perks, connect with your community, and
            earn rewards.
          </TextG14> */}
        </VStack>

        {/* Phone Image */}
        <Center py={4}>
          <Image
            src={PhoneImage}
            alt="Walkabout App on Phone"
            maxH="300px"
            maxW="200px"
            objectFit="contain"
          />
        </Center>

        {/* App Store Buttons - Match original sizes */}
        <VStack spacing={4} w="100%" maxW="280px">
          <ExternalLink href={APPLE_STORE_LINK} isExternal>
            <Image
              w="190px"
              h="auto"
              src={AppStoreImage}
              alt="Download on the App Store"
              borderRadius="8px"
            />
          </ExternalLink>

          <ExternalLink href={GOOGLE_STORE_LINK} isExternal>
            <Image
              w="190px"
              h="auto"
              src={PlayStoreImage}
              alt="Get it on Google Play"
              borderRadius="8px"
            />
          </ExternalLink>
        </VStack>

        <Box borderRadius="12px" p={4} maxW="300px" mt={4}>
          <TextG14
            fontSize="14px"
            lineHeight="18px"
            fontWeight="400"
            color={theme.colors.darkGrey || '#333'}>
            Search for{' '}
            <span style={{color: theme.colors.rose || '#e53e3e', fontWeight: '600'}}>
              Walkabout.app
            </span>{' '}
            on Apple and Google app stores, or follow the links above.
          </TextG14>
        </Box>
      </VStack>
    </Box>
  );
};

export default MobileDownloadApp;
